// base
import { createSlice } from '@reduxjs/toolkit';
import { NOTICE_SLICE_NAME } from '../actions/notice.action';
import {
  getNotices,
  getNoticeDetail,
  createNotice,
  updateNotice,
  deleteNotice,
  // getNoticePic,
  createNoticeReply,
  updateNoticeReply,
  deleteNoticeReply,
  deleteNoticeAttachment,
  createNoticeAttachment
} from '../thunks/notice.thunk';
//utils
import { dateToString } from 'utils/formatDateToString';
import { IDialogType, NoticeState } from '../models/notice.model';
import dayjs from 'dayjs';
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from 'constants/const';

const initialState: NoticeState = {
  noticeDetail: {
    id: '',
    userName: '',
    category: 'GENERAL',
    createdBy: '',
    title: '',
    content: '',
    replyDtoList: [],
    files: [],
    attachments: [],
    lastModifiedDate: dateToString(new Date()),
    userId: '',
    enabled: false,
    createdDate: '',
    lastModifiedBy: '',
    viewCount: 0,
    replyCount: 0
  },
  notices: [],
  totalMap: {
    totalElements: 0,
    totalPages: 0
  },
  dialog: {
    type: IDialogType.none,
    message: undefined,
    isNavigate: false,
    callback: () => {}
  },

  fetchNoticesRequest: {
    keyword: '',
    startDate: dateToString(dayjs().subtract(1, 'year')),
    endDate: dateToString(dayjs()),
    category: 'ALL',
    page: DEFAULT_PAGE,
    size: DEFAULT_PAGE_SIZE
  },
  replyDetail: {
    id: '',
    userId: '',
    userName: '',
    content: '',
    createdDate: '',
    lastModifiedDate: ''
  }
};

const noticeSlice = createSlice({
  name: NOTICE_SLICE_NAME,
  initialState,
  reducers: {
    changeNoticeDetail(state, action) {
      state.noticeDetail = {
        ...state.noticeDetail,
        ...action.payload
      };
    },

    resetNoticeDetail(state) {
      state.noticeDetail = initialState.noticeDetail;
    },

    changeReplyDetail(state, action) {
      state.replyDetail = {
        ...state.replyDetail,
        ...action.payload
      };
    },
    resetReplyDetail(state) {
      state.replyDetail = initialState.replyDetail;
    },

    updateNoticeAttachments(state, action) {
      state.noticeDetail.attachments = action.payload;
    },

    changeDialog(state, action) {
      state.dialog = {
        ...state.dialog,
        ...action.payload
      };
    },

    resetDialog(state) {
      state.dialog = initialState.dialog;
    },

    changeFetchNoticeRequest: (state, action) => {
      state.fetchNoticesRequest = {
        ...state.fetchNoticesRequest,
        ...action.payload
      };
    },

    resetFetchNoticeRequest: (state) => {
      state.fetchNoticesRequest = initialState.fetchNoticesRequest;
    },

    resetAll: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(getNotices.fulfilled, (state, action) => {
        const response = action.payload;

        state.notices = response.resultList;
        state.totalMap = response.totalMap;
      })

      .addCase(getNotices.rejected, (state, action) => {
        state.dialog.message = action.payload.message;
      })

      .addCase(getNoticeDetail.fulfilled, (state, action) => {
        state.noticeDetail = action.payload.resultObject;
      })

      .addCase(createNotice.fulfilled, (state, action) => {
        state.dialog.type = IDialogType.alert;
        state.dialog.message = action.payload.message;
        state.dialog.isNavigate = true;
      })

      .addCase(createNotice.rejected, (state, action) => {
        state.dialog.type = IDialogType.alert;
        state.dialog.message = action.payload.message;
      })

      .addCase(updateNotice.fulfilled, (state, action) => {
        state.dialog.type = IDialogType.alert;
        state.dialog.message = action.payload.message;
        state.dialog.isNavigate = true;
      })

      .addCase(updateNotice.rejected, (state, action) => {
        state.dialog.type = IDialogType.alert;
        state.dialog.message = action.payload.message;
      })

      .addCase(deleteNotice.fulfilled, (state, action) => {
        state.dialog.type = IDialogType.alert;
        const res = action.payload;
        state.dialog.message = res.message;
        state.dialog.isNavigate = true;
      })

      .addCase(deleteNotice.rejected, (state, action) => {
        state.dialog.type = IDialogType.alert;
        state.dialog.message = action.payload.message;
      })

      .addCase(createNoticeReply.fulfilled, (state, action) => {
        state.dialog.type = IDialogType.alert;
        state.dialog.message = action.payload.message;
      })

      .addCase(createNoticeReply.rejected, (state, action) => {
        state.dialog.type = IDialogType.alert;
        state.dialog.message = action.payload.message;
      })

      .addCase(updateNoticeReply.fulfilled, (state, action) => {
        state.dialog.type = IDialogType.alert;
        state.dialog.message = action.payload.message;
      })

      .addCase(deleteNoticeReply.fulfilled, (state, action) => {
        state.dialog.type = IDialogType.alert;
        state.dialog.message = action.payload.message;
      })

      .addCase(deleteNoticeReply.rejected, (state, action) => {
        state.dialog.type = IDialogType.alert;
        state.dialog.message = action.payload.message;
      })

      .addCase(deleteNoticeAttachment.fulfilled, (state, action) => {
        state.dialog.type = IDialogType.alert;
        state.dialog.message = action.payload.message;
      })

      .addCase(deleteNoticeAttachment.rejected, (state, action) => {
        state.dialog.type = IDialogType.alert;
        state.dialog.message = action.payload.message;
      })

      .addCase(createNoticeAttachment.fulfilled, (state, action) => {
        state.dialog.type = IDialogType.alert;
        state.dialog.message = action.payload.message;
      })

      .addCase(createNoticeAttachment.rejected, (state, action) => {
        state.dialog.type = IDialogType.alert;
        state.dialog.message = action.payload.message;
      });
  }
});

export const notice = noticeSlice.name;
export const noticeReducer = noticeSlice.reducer;
export const noticeAction = noticeSlice.actions;
export const {
  changeFetchNoticeRequest,
  changeNoticeDetail,
  resetNoticeDetail,
  changeDialog,
  resetDialog,
  resetFetchNoticeRequest,
  resetAll,
  changeReplyDetail,
  resetReplyDetail
} = noticeSlice.actions;
export default noticeSlice.reducer;
